import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getSystemConfigData, addSystemConfigData } from '../../../store/actions/SystemDefaultActions';
import { getProjectRateList, addProjectRateDetails } from '../../../store/actions/ProjectActions';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';

const SystemDefault = (props) => {

    const dispatch = useDispatch();

    const [config, setConfig] = useState([]);
    const [configOption, setConfigOption] = useState([]);
    const [log, setLog] = useState(1);
    const [pages, setPages] = useState(1);
    const [timesheet, setTimesheet] = useState(1);
    const [weekend, setWeekend] = useState(1);
    const [leave, setLeave] = useState(1);
    const [summary, setSummary] = useState(1);

    const [projectList, setProjectList] = useState([]);

    useEffect(() => {
        dispatch(globalLoadingAction(true));
        dispatch(getSystemConfigData(props.systemAdmin, props.history));
        dispatch(getProjectRateList(props.systemAdmin,props.history));
    }, []);

    useEffect(() => {
        if (props.filterOption) {
            setConfigOption(props.filterOption);
            getConfigData();
        }
    }, [props.filterOption]);

    useEffect(() => {
        if (props.projectRateList.length > 0) {
            setProjectList(props.projectRateList);
        }
    }, [props.projectRateList]);


    const submitHandler = async () => {
        const array = [...config];
        array[0].allow_user_to_change_opton = log == 1 ? true : false;
        array[0].allow_user_to_change_pagination_option = pages == 1 ? true : false;
        array[1].allow_user_to_change_opton = timesheet == 1 ? true : false;
        array[2].allow_user_to_change_opton = weekend == 1 ? true : false;
        array[3].allow_user_to_change_opton = leave == 1 ? true : false;
        array[4].allow_user_to_change_opton = summary == 1 ? true : false;
        dispatch(globalLoadingAction(true));
        await dispatch(addSystemConfigData(array, props.history));

        const details = projectList
            .filter((item) => String(item.rate).trim() !== "")
            .map((item) => ({
                project_id: item._id,
                rate: parseInt(item.rate, 10),
            }));
        console.log('details..', details)
        // dispatch project rate details
        if (details.length > 0) {
            await dispatch(addProjectRateDetails(details, props.history));
        }
    }

    const getConfigData = () => {
        let array = [];
        let obj = {};
        setLog(props.filterOption[0]?.options?.allow_user_to_change ? 1 : 0);
        setPages(props.filterOption[0]?.pagination_option?.allow_user_to_change ? 1 : 0);
        setTimesheet(props.filterOption[1]?.options?.allow_user_to_change ? 1 : 0);
        setWeekend(props.filterOption[2]?.options?.allow_user_to_change ? 1 : 0);
        setSummary(props.filterOption[4]?.options?.allow_user_to_change ? 1 : 0);
        props.filterOption.forEach((item, index) => {
            if (item.filter_type == 1) {
                item.options.data.forEach((option, j) => {
                    if (option.selected) {
                        obj = { filter_type: item.filter_type, option_id: option.option_id, allow_user_to_change_opton: item.options.allow_user_to_change }
                    }
                });
                item.pagination_option.data.forEach((option, j) => {
                    if (option.selected) {
                        obj = { filter_type: item.filter_type, option_id: option.option_id, pagination_option_id: option.option_id, allow_user_to_change_opton: item.options.allow_user_to_change, allow_user_to_change_pagination_option: item.pagination_option.allow_user_to_change }
                    }
                });
            } else {
                item.options.data.forEach((option, j) => {
                    if (option.selected) {
                        obj = { filter_type: item.filter_type, option_id: option.option_id, allow_user_to_change_opton: item.options.allow_user_to_change }
                    }
                });
            }

            array.push(obj);
        });
        setConfig(array);

    }

    const onConfigCaptureHandler = (val, type, index) => {
        let configArray = [...configOption];
        let array = [...config];
        configArray[type].options.data.forEach((item, i) => {
            if (index == i) {
                configArray[type].options.data[i].selected = true;
            } else {
                configArray[type].options.data[i].selected = false;
            }
        });
        array[type].option_id = val ? parseInt(val) : 0;
        setConfigOption(configArray);
        setConfig(array);

    }

    const onConfigPaginationHandler = (val, type, index) => {
        let configArray = [...configOption];
        let array = [...config];
        configArray[type].pagination_option.data.forEach((item, i) => {
            if (index == i) {
                configArray[type].pagination_option.data[i].selected = true;
            } else {
                configArray[type].pagination_option.data[i].selected = false;
            }
        });
        array[type].pagination_option_id = val ? parseInt(val) : 0;
        setConfigOption(configArray);
        setConfig(array);
    }

    const onRateHandler = (value, index) => {
        let onlyNumbers = value.replace(/[^0-9]/g, "");

        // Limit to max 3 digits
        if (onlyNumbers.length > 3) {
            onlyNumbers = onlyNumbers.slice(0, 3);
        }

        let array = [...projectList];
        array[index].rate = onlyNumbers;
        setProjectList(array);
    };


    return (
        <>
            <div className="row">
                <div className="title-body">
                    <h3>Default</h3>
                    <p>Manage Company/Organization Information such as name, type, location address and contacts.</p>
                </div>
                <div className="account-setting-content">
                    <div className="row">
                        <div className="col-xl-11 col-md-12">

                            <div className="account-setting-card">

                                <fieldset className="form-group">
                                    <div className="system-default">
                                        <div className='system-title'>
                                            <h3>Project Rate</h3>
                                        </div>
                                        <div className='project-default-rate-form'>
                                            {/* <div className='form-group default-project'>
                                                <label className="mb-1">
                                                    <strong>Project</strong>
                                                </label>
                                                <div className="select-drop-down filter-drop-down">
                                                    <span><i class="fa fa-angle-down"></i></span>
                                                    <select
                                                        defaultValue={"option"}
                                                        className="form-control filter-control"
                                                        value={project}
                                                        onChange={(e) => onProjectHandler(e.target.value)}>
                                                        <option value="">Select project</option>
                                                        {
                                                            props?.projectRateList.map((item, index) => {
                                                                return <option key={index} value={item._id}>{item.project_id}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                            </div> */}
                                            {projectList.map((item, index) => {
                                                return (
                                                    <div key={index} className='default-project-rate'>
                                                        <div className='default-project'>
                                                            <p>{item?.project_id}</p>
                                                        </div>
                                                        <input
                                                            className="default-rate"
                                                            value={item?.rate}
                                                            placeholder='Rate'
                                                            onChange={(e) => onRateHandler(e.target.value, index)}
                                                        />
                                                    </div>
                                                );
                                            })}


                                        </div>
                                    </div>

                                </fieldset>

                                <fieldset className="form-group">
                                    <div className="system-default">
                                        <div className='system-title'>
                                            <h3>{configOption[0]?.filter_name}</h3>
                                        </div>

                                        <div className="system-default-item">

                                            <div className='system-item-group'>
                                                <div className='system-header-title'>
                                                    <p>{configOption[0]?.options?.title}</p>
                                                </div>
                                                <div className='system-title-item'>
                                                    <div className="transaction-check-group">
                                                        {
                                                            configOption[0]?.options?.data?.map((item, index) => {
                                                                return (
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="timeOption"
                                                                            disabled={!configOption[0]?.options?.is_editable}
                                                                            value={item.option_id}
                                                                            checked={item.selected}
                                                                            onChange={(e) => onConfigCaptureHandler(e.target.value, 0, index)}
                                                                        />
                                                                        <label className="form-check-label">
                                                                            {item.option_name}
                                                                        </label>
                                                                    </div>

                                                                );
                                                            })
                                                        }

                                                    </div>

                                                </div>
                                            </div>
                                            {props.systemAdmin ?
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>Allow user to change</p>
                                                    </div>
                                                    <div className='system-title-item'>

                                                        <div className="radio-system-check-group">
                                                            <input
                                                                id="allowRangeOn"
                                                                type="radio"
                                                                name="allowRange"
                                                                disabled={!configOption[0]?.options?.is_editable}
                                                                value={1}
                                                                checked={log == 1}
                                                                onChange={(e) => setLog(e.target.value)}
                                                            />
                                                            <label htmlFor="allowRangeOn">
                                                                Yes
                                                            </label>
                                                            <input
                                                                id="allowRangeOff"
                                                                type="radio"
                                                                name="allowRange"
                                                                disabled={!configOption[0]?.options?.is_editable}
                                                                value={0}
                                                                checked={log == 0}
                                                                onChange={(e) => setLog(e.target.value)}
                                                            />
                                                            <label htmlFor="allowRangeOff">
                                                                No
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                            <div className='system-item-group'>
                                                <div className='system-header-title'>
                                                    <p>{configOption[0]?.pagination_option?.title}</p>
                                                </div>
                                                <div className='system-title-item'>

                                                    <div className="transaction-check-group">
                                                        {
                                                            configOption[0]?.pagination_option?.data?.map((item, index) => {
                                                                return (
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="pagination"
                                                                            disabled={!configOption[0]?.pagination_option?.is_editable}
                                                                            value={item.option_id}
                                                                            checked={item.selected}
                                                                            onChange={(e) => onConfigPaginationHandler(e.target.value, 0, index)}
                                                                        />
                                                                        <label className="form-check-label">
                                                                            {item.option_name}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                            {props.systemAdmin ?
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>Allow user to change</p>
                                                    </div>
                                                    <div className='system-title-item'>

                                                        <div className="radio-system-check-group">

                                                            <input
                                                                id="allowPageOn"
                                                                type="radio"
                                                                name="allowPage"
                                                                disabled={!configOption[0]?.pagination_option?.is_editable}
                                                                value={1}
                                                                checked={pages == 1}
                                                                onChange={(e) => setPages(e.target.value)}
                                                            />
                                                            <label htmlFor="allowPageOn">
                                                                Yes
                                                            </label>
                                                            <input
                                                                id="allowPageOff"
                                                                type="radio"
                                                                name="allowPage"
                                                                disabled={!configOption[0]?.pagination_option?.is_editable}
                                                                value={0}
                                                                checked={pages == 0}
                                                                onChange={(e) => setPages(e.target.value)}
                                                            />
                                                            <label htmlFor="allowPageOff">
                                                                No
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                                : null}


                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset className="form-group mt-4">
                                    <div className="system-default">
                                        <div className='system-title'>
                                            <h3>{configOption[1]?.filter_name}</h3>
                                        </div>


                                        <div className="system-default-item">
                                            <div className='system-item-group'>
                                                <div className='system-header-title'>
                                                    <p>{configOption[1]?.options?.title}</p>
                                                </div>
                                                <div className='system-title-item'>
                                                    <div className="transaction-check-group me-2">
                                                        {
                                                            configOption[1]?.options?.data?.map((item, index) => {
                                                                return (
                                                                    <div className="form-check">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="timeSheet"
                                                                            disabled={!configOption[1]?.options?.is_editable}
                                                                            value={item.option_id}
                                                                            checked={item.selected}
                                                                            onChange={(e) => onConfigCaptureHandler(e.target.value, 1, index)}
                                                                        />
                                                                        <label className="form-check-label">
                                                                            {item.option_name}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {props.systemAdmin ?
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>Allow user to change</p>
                                                    </div>
                                                    <div className='system-title-item'>

                                                        <div className="radio-system-check-group">

                                                            <input
                                                                id="allowSheetOn"
                                                                type="radio"
                                                                name="allowSheet"
                                                                disabled={!configOption[1]?.options?.is_editable}
                                                                value={1}
                                                                checked={timesheet == 1}
                                                                onChange={(e) => setTimesheet(e.target.value)}
                                                            />
                                                            <label htmlFor="allowSheetOn">
                                                                Yes
                                                            </label>


                                                            <input
                                                                id="allowSheetOff"
                                                                type="radio"
                                                                name="allowSheet"
                                                                value={0}
                                                                checked={timesheet == 0}
                                                                disabled={!configOption[1]?.options?.is_editable}
                                                                onChange={(e) => setTimesheet(e.target.value)}
                                                            />
                                                            <label htmlFor="allowSheetOff">
                                                                No
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                        </div>

                                    </div>
                                </fieldset>

                                <fieldset className="form-group mt-4">
                                    <div className="system-default">
                                        <div className='system-title'>
                                            <h3>{configOption[2]?.filter_name}</h3>
                                        </div>


                                        <div className="system-default-item">
                                            <div className='system-item-group'>
                                                <div className='system-header-title'>
                                                    <p>{configOption[2]?.options?.title}</p>
                                                </div>
                                                <div className='system-title-item'>
                                                    <div className="radio-system-check-group">
                                                        {
                                                            configOption[2]?.options?.data?.map((item, index) => {
                                                                return (
                                                                    <>
                                                                        <input
                                                                            id={`weekend${item.option_name}`}
                                                                            type="radio"
                                                                            name="weekend"
                                                                            disabled={!configOption[2]?.options?.is_editable}
                                                                            value={item.option_id}
                                                                            checked={item.selected}
                                                                            onChange={(e) => onConfigCaptureHandler(e.target.value, 2, index)}
                                                                        />
                                                                        <label htmlFor={`weekend${item.option_name}`}>
                                                                            {item.option_name}
                                                                        </label>
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {props.systemAdmin ?
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>Allow user to change</p>
                                                    </div>
                                                    <div className='system-title-item'>
                                                        <div className="radio-system-check-group">
                                                            <input
                                                                id="allowWeekendOn"
                                                                type="radio"
                                                                name="allowWeekend"
                                                                disabled={!configOption[2]?.options?.is_editable}
                                                                value={1}
                                                                checked={weekend == 1}
                                                                onChange={(e) => setWeekend(e.target.value)}
                                                            />
                                                            <label htmlFor="allowWeekendOn">
                                                                Yes
                                                            </label>

                                                            <input
                                                                id="allowWeekendOff"
                                                                type="radio"
                                                                name="allowWeekend"
                                                                value={0}
                                                                checked={weekend == 0}
                                                                disabled={!configOption[2]?.options?.is_editable}
                                                                onChange={(e) => setWeekend(e.target.value)}
                                                            />
                                                            <label htmlFor="allowWeekendOff">
                                                                No
                                                            </label>

                                                        </div>
                                                    </div>

                                                </div>
                                                : null}
                                        </div>

                                    </div>
                                </fieldset>


                                <fieldset className="form-group mt-4">
                                    <div className="system-default">
                                        <div className='system-title'>
                                            <h3>{configOption[3]?.filter_name}</h3>
                                        </div>


                                        <div className="system-default-item">
                                            <div className='system-item-group'>
                                                <div className='system-header-title'>
                                                    <p>{configOption[3]?.options?.title}</p>
                                                </div>
                                                <div className='system-title-item'>
                                                    <div className="radio-system-check-group">
                                                        {
                                                            configOption[3]?.options?.data?.map((item, index) => {
                                                                return (

                                                                    <>
                                                                        <input
                                                                            id={`leave${item.option_name}`}
                                                                            type="radio"
                                                                            name="leave"
                                                                            disabled={!configOption[3]?.options?.is_editable}
                                                                            value={item.option_id}
                                                                            checked={item.selected}
                                                                            onChange={(e) => onConfigCaptureHandler(e.target.value, 3, index)}
                                                                        />
                                                                        <label htmlFor={`leave${item.option_name}`}>
                                                                            {item.option_name}
                                                                        </label>
                                                                    </>


                                                                );
                                                            })
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                            {props.systemAdmin ?
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>Allow user to change</p>
                                                    </div>
                                                    <div className='system-title-item'>

                                                        <div className="radio-system-check-group">

                                                            <input
                                                                id="allowLeaveOn"
                                                                type="radio"
                                                                name="allowLeave"
                                                                disabled={!configOption[3]?.options?.is_editable}
                                                                value={1}
                                                                checked={leave == 1}
                                                                onChange={(e) => setLeave(e.target.value)}
                                                            />
                                                            <label htmlFor="allowLeaveOn">
                                                                Yes
                                                            </label>

                                                            <input
                                                                id="allowLeaveOff"
                                                                type="radio"
                                                                name="allowLeave"
                                                                value={0}
                                                                checked={leave == 0}
                                                                disabled={!configOption[3]?.options?.is_editable}
                                                                onChange={(e) => setLeave(e.target.value)}
                                                            />
                                                            <label htmlFor="allowLeaveOff">
                                                                No
                                                            </label>

                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                        </div>

                                    </div>
                                </fieldset>



                                {props.systemAdmin && (
                                    <fieldset className="form-group mt-4">
                                        <div className="system-default">
                                            <div className='system-title'>
                                                <h3>{configOption[4]?.filter_name}</h3>
                                            </div>


                                            <div className="system-default-item">
                                                <div className='system-item-group'>
                                                    <div className='system-header-title'>
                                                        <p>{configOption[4]?.options?.title}</p>
                                                    </div>
                                                    <div className='system-title-item'>
                                                        {/* <div className="transaction-check-group me-2">
                                                            {
                                                                configOption[4]?.options?.data?.map((item, index) => {
                                                                    return (
                                                                        <div className="form-check">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="summary"
                                                                                disabled={!props.systemAdmin}
                                                                                value={item.option_id}
                                                                                checked={item.selected}
                                                                                onChange={(e) => onConfigCaptureHandler(e.target.value, 4, index)}
                                                                            />
                                                                            <label className="form-check-label">
                                                                                {item.option_name}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div> */}
                                                        <div className="radio-system-check-group">
                                                            {
                                                                configOption[4]?.options?.data?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <input
                                                                                id={`summary${item.option_name}`}
                                                                                type="radio"
                                                                                name="summary"
                                                                                disabled={!props.systemAdmin}
                                                                                value={item.option_id}
                                                                                checked={item.selected}
                                                                                onChange={(e) => onConfigCaptureHandler(e.target.value, 4, index)}
                                                                            />
                                                                            <label htmlFor={`summary${item.option_name}`}>
                                                                                {item.option_name}
                                                                            </label>
                                                                        </>
                                                                    );
                                                                })
                                                            }
                                                        </div>


                                                    </div>
                                                    {/* {props.systemAdmin ?
                                                    <div className='system-title-item'>
                                                        <p>Allow user to change</p>
                                                        <div className="transaction-check-group">
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="allowSummary"
                                                                    disabled={!configOption[4]?.options?.is_editable}
                                                                    value={1}
                                                                    checked={summary == 1}
                                                                    onChange={(e) => setSummary(e.target.value)}
                                                                />
                                                                <label className="form-check-label">
                                                                    Yes
                                                                </label>
                                                            </div>
                                                            <div className="form-check">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="allowSummary"
                                                                    value={0}
                                                                    checked={summary == 0}
                                                                    disabled={!configOption[4]?.options?.is_editable}
                                                                    onChange={(e) => setSummary(e.target.value)}
                                                                />
                                                                <label className="form-check-label">
                                                                    NO
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null} */}
                                                </div>
                                            </div>

                                        </div>
                                    </fieldset>)}

                                <div className="system-submit-container">
                                    <button type='button' onClick={submitHandler}>Submit</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        screenVisible: state.systemconfig.screenVisible,
        filterOption: state.systemconfig.options,
        systemAdmin: state.auth.systemAdmin,
        projectRateList: state.project.projectRateList
    };
};

export default connect(mapStateToProps)(SystemDefault);